export const menu_items = [
    {
      title: 'HOME',
      url: '/',
    },
    {
      title: 'PROJECTS',
      url: '/projects',
    },
    {
      title: 'ABOUT',
      url: '/about',
    },
    {
      title: 'RESUME',
      url: '/resume',
    },
    {
      title: 'APPS',
      url: '/apps',
      submenu: [
          {
              title: 'Snake Game',
              url: 'snake',
          },
          {
              title: 'Chat',
              url: 'chat',
          },
      ],
    },
  ];